import { createSlice } from '@reduxjs/toolkit';
import { partition, sortBy } from 'lodash';

const initialState = {
	companies: [],
	currentCompany: null,
	loading: true,
};

const isAuthorized = (comp) => {
	if (!!comp.isAuthorized)
		return true;
	return false;
}

const orderCompanies = (data) => {
	var comps = !!data ? data : [];
	comps = sortBy(comps, ["cif", "name"]);
	const [ac, uc] = partition(comps, isAuthorized);
	comps = ac.concat(uc);

	return comps;
}

export const companySlice = createSlice({
	name: 'company',
	initialState,
	reducers: {
		addCompany: (state, action) => {
			state.companies = [...state.companies, action.payload].sort((a, b) => a.name > b.name ? 1 : -1);
			if (state.currentCompany?.id === "")
				state.currentCompany = action.payload;
		},
		removeCompany: (state, action) => {
			state.companies = state.companies.filter(company => company.id !== action.payload);
			if (state.currentCompany?.id === action.payload)
				state.currentCompany = null;
		},
		updateCompany: (state, action) => {
			if (!action.payload)
				return;

			let index = state.companies.findIndex(company => company.id === action.payload.id);
			if (index > -1) {
				let left, right;

				if (index > 0)
					left = state.companies.slice(0, index);
				else
					left = [];

				if (index < state.companies.length)
					right = state.companies.slice(index + 1, state.companies.length);
				else
					right = [];

				state.companies = orderCompanies([...left, action.payload, ...right]);
				if (!!state.currentCompany && state.currentCompany.id === action.payload.id)
					state.currentCompany = action.payload;
			}
		},
		setCompaniesLoading: (state) => {
			state.loading = true;
			state.companies = [];
		},

		setCompanies: (state, action) => {
			state.loading = false;
			state.companies = orderCompanies(action.payload || []);

			// Alege o firmă implicită doar dacă nu avem una validă
			if (
				!state.currentCompany ||
				!state.companies.some(c => String(c.id) === String(state.currentCompany.id))
			) {
				state.currentCompany =
					state.companies.find(c => c.isAuthorized) ||
					state.companies[0] ||
					null;
			}
		},
		selectCompany: (state, action) => {
			if (!!action.payload)
				state.currentCompany = state.companies.find(company => company.id === action.payload) ?? null;
		},
		clear: (state) => {
			return initialState;
		},
	},
});

export const selectCompanies = (state) => state.companyReducer.companies;
export const selectCurrentCompany = (state) => state.companyReducer.currentCompany;
export const selectCompaniesLoading = (state) => state.companyReducer.loading;
export const { addCompany, removeCompany, updateCompany, setCompanies, setCompaniesLoading, selectCompany, clearCompanyData } = companySlice.actions;

export default companySlice.reducer;
